import React from 'react';
import PropTypes from 'prop-types'
import Icon from "../Icon";

const ActionButton = ({ icon, className, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`action-button background-transition s-cross-center s-main-center cursor-pointer s-border-body-alt outline-none s-bg-body-alt s-hover-bg-body normal-radius s-w-32px s-h-32px ${className}`}
    >
      <Icon
        className="icon"
        svg={icon}
        color="var(--text-color)"
      />
    </button>
  );
};

ActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
}

ActionButton.defaultProps = {
  className: '',
}

export default ActionButton;
